import * as React from 'react';
import classNames from 'classnames';

export interface IProps {
  name: string;
  className?: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

const icons = {};
const context = require.context(
  '!babel-loader?compact=true!react-svg-loader?jsx=true!./icons',
  false,
  /\.svg$/
);

context.keys().forEach((filename: string) => {
  const name = filename
    .slice(2)
    .replace(/\.icon\.svg/, '');

  icons[name] = context(filename).default;
});

const Icon = ({ name, className, size = 24, style, color }: IProps) => {
  const Icons = icons[name];

  return (
    <Icons
      className={classNames('icon', className)}
      width={size}
      height={size}
      color={color}
      style={style}
    />
  );
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon/index.tsx